import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'whatwg-fetch';

document.addEventListener('DOMContentLoaded', function () {

    function bindDisplayMoreClick() {
        var links = document.querySelectorAll('a.page-list__show-more-link');
        Array.prototype.forEach.call(links, function (link) {
            link.removeEventListener('click', handleLinkClick);
            link.addEventListener('click', handleLinkClick);
        });
    }

    function handleLinkClick(evt) {
        evt.preventDefault();
        evt.stopPropagation();

        var link = this;
        var linkContainerParent = this.parentNode.parentNode;
        var list = linkContainerParent.querySelector('.page-list');

        var pageListSourceId = parseInt(linkContainerParent.querySelector('input[name="pageListSourceId"]').value);
        var nextPageIndex = linkContainerParent.querySelector('input[name="nextPageIndex"]');
        var pageCount = parseInt(linkContainerParent.querySelector('input[name="pageCount"]').value);
        var targetPageIndex = parseInt(nextPageIndex.value);

        var url = `/pagelist/pagelistitems/?pageListSourceId=${pageListSourceId}&pageIndex=${targetPageIndex}&t=${new Date().getTime()}`;

        nextPageIndex.value = targetPageIndex + 1;

        link.classList.add('loading');

        fetch(url)
            .then(response => response.text())
            .then(function (data) {

                var blockContainer = link.closest('.block__container');
                if (blockContainer) {
                    blockContainer.style.height = '';
                }

                if (data) {
                    list.insertAdjacentHTML('beforeend', data);
                }

                bindDisplayMoreClick();
                cmn_triggerDomUpdateEvent();
            })
            .finally(function () {
                link.classList.remove('loading');
                if ((targetPageIndex + 1) >= pageCount)
                    link.style.display = 'none';
            });

        window.history.pushState('', '', document.addUrlParam('pl' + pageListSourceId, targetPageIndex));
    }

    bindDisplayMoreClick();
});
